import { getLicenseLabel } from '@/utils/helpers/userManagementHelper';
import { LICENSE_TYPE } from '@/consts/common';
import { ILicenseProduct, ILicenseType } from '@/services/licenses/types';
import { getI18nMessage } from '@/utils/helpers/i18nHelper';

export const LICENSE_MANAGEMENT_STATUS = {
  ALL: 'all', // not a real status, used for filtering
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  AVAILABLE: 'AVAILABLE',
  CANCELLED: 'CANCELLED',
} as const;

export const LICENSE_PRODUCT = {
  ALL: 'all', // not a real product, used for filtering
  HOLOXR: 'holoxr',
  // HOLOPOD: 'holopod',
} as const;

export const LICENSE_MANAGEMENT_FILTER_OPTIONS = [
  ...Object.values(LICENSE_TYPE).map((licenseType) => ({
    id: licenseType,
    name: getLicenseLabel(licenseType as ILicenseType),
  })),
];

export const LICENSE_PRODUCT_FILTER_OPTIONS = [
  { id: LICENSE_PRODUCT.ALL, name: 'All products' },
  { id: LICENSE_PRODUCT.HOLOXR, name: 'HoloXR' },
  // { id: LICENSE_PRODUCT.HOLOPOD, name: 'HoloPod' },
];

export const getProductLabel = (product: ILicenseProduct) => {
  if (product === 'holoxr') return 'HoloXR';
  return 'HoloPod';
};

export const getLicenseManagementStatusFilterOptions = () => [
  {
    id: LICENSE_MANAGEMENT_STATUS.ALL,
    name: getI18nMessage('licenseManagement', 'STATUS_FILTERS.ALL', 'All statuses'),
  },
  {
    id: LICENSE_MANAGEMENT_STATUS.ACTIVE,
    name: getI18nMessage('licenseManagement', 'STATUS_FILTERS.ACTIVE', 'Active'),
  },
  {
    id: LICENSE_MANAGEMENT_STATUS.EXPIRED,
    name: getI18nMessage('licenseManagement', 'STATUS_FILTERS.EXPIRED', 'Expired'),
  },
  {
    id: LICENSE_MANAGEMENT_STATUS.AVAILABLE,
    name: getI18nMessage('licenseManagement', 'STATUS_FILTERS.AVAILABLE', 'Available'),
  },
  {
    id: LICENSE_MANAGEMENT_STATUS.CANCELLED,
    name: getI18nMessage('licenseManagement', 'STATUS_FILTERS.CANCELLED', 'Cancelled'),
  },
];
